import { render, staticRenderFns } from "./ScormPlayer.vue?vue&type=template&id=17045784&scoped=true&"
import script from "./ScormPlayer.vue?vue&type=script&lang=js&"
export * from "./ScormPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ScormPlayer.vue?vue&type=style&index=0&id=17045784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17045784",
  null
  
)

export default component.exports